module.exports = {
    following:'Following',
    name:'Name'
}